import "./_stage-styles.scss";

import './stage';